import Keycloak from 'keycloak-js';
import * as actions from '@/store/actions';
import { store } from '@/store';
import { SHOULD_LOGOUT_STORAGE_KEY } from './utils/constants';



export const REFRESH_TOKEN_INTERVAL = 55; // in seconds

// Indicates that the app is in the process of switching to a new company session
// (triggered by the superadmin "Login as administrator" flow).
// Prevents the login saga from running with stale session data during the switch.
let isSwitchingSession = false;

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_AUTH_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM as string,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string
});

keycloak.init({
    onLoad: 'login-required',
    checkLoginIframe: false,
    redirectUri: `${window.location.origin}/#/auth`,
}).then((isAuthenticated: boolean) => {
    if (isSwitchingSession) {
        return;
    }
    if (isAuthenticated) {
        store.dispatch(actions.authSuccess());
    } else {
        store.dispatch(actions.authLogout());
    }
}).catch((err: unknown) => {
    console.error(err);
});

keycloak.onAuthSuccess = () => {
    const switchAccountEmail = sessionStorage.getItem(SHOULD_LOGOUT_STORAGE_KEY);
    if(switchAccountEmail) {
        sessionStorage.removeItem(SHOULD_LOGOUT_STORAGE_KEY);
        isSwitchingSession = true;

        // Compare the requested account email with the currently logged-in user.
        // If it's a different user, we need a full logout to show the login form.
        const currentEmail = (keycloak.tokenParsed as any)?.email?.toLowerCase();
        const isSameUser = currentEmail === switchAccountEmail.toLowerCase();

        store.dispatch(actions.KEYCLOAK_API_LOGOUT.request({ isSameUser }));
        return;
    }
};

keycloak.onAuthRefreshSuccess = () => {
    store.dispatch(actions.authSuccess());
};

keycloak.onAuthError = (err: unknown) => {
    store.dispatch(actions.authLogout());
};

keycloak.onAuthRefreshError = () => {
    const err = new Error('Token refresh error;');
    store.dispatch(actions.authFail(err));
};

keycloak.onTokenExpired = () => {
    keycloak.updateToken(REFRESH_TOKEN_INTERVAL);
};

export default keycloak
